import { Box, Button, Grid, styled, Typography } from "@mui/material";
import React from "react";

/** Flex row for filter selectors in ViewWrapper's aboveContent, wraps on smaller screens. */
export const FilterBar = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  rowGap: theme.spacing(2),
  flexWrap: "nowrap",
  [theme.breakpoints.down("lg")]: {
    flexWrap: "wrap",
  },
}));

const StyledSearchRow = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}));

/** Grid row containing the search input and action button. */
export const SearchRow = (props: React.ComponentProps<typeof Grid>) => (
  <StyledSearchRow
    container
    alignItems="center"
    justifyContent="space-between"
    direction="row"
    {...props}
  />
);

/** Primary action button (e.g. New Job, New Request). */
export const ActionButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(4),
})) as typeof Button;

/** Empty state message shown when a query returns no results. */
export const NoneFoundMessage = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Box
    sx={{
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "2rem 1rem",
      textAlign: "center",
    }}
  >
    <Typography variant="h4" color="secondary">
      {children}
    </Typography>
  </Box>
);
